import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getDeductions(params: any): AxiosPromise {
    return EndPointService.get('/deductions', { params });
}

function getDeduction(id: number | string): AxiosPromise {
    return EndPointService.get(`/deductions/${id}`);
}

function deleteDeduction(id: number | string): AxiosPromise {
    return EndPointService.delete(`/deductions/${id}`);
}

function createDeduction(payload: any): AxiosPromise {
    return EndPointService.post('/deductions', payload);
}

function updateDeduction(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/deductions/${id}`, { ...payload });
}

export default {
    getDeductions,
    getDeduction,
    deleteDeduction,
    createDeduction,
    updateDeduction,
};
